import AxiosService from '../../gateway/rest/AxiosService'

class SharePointSettingsRestService {

    static sharePointCustomFieldEndpoint = '/o365/sharepoint/customfields'

    static getAll(): Promise<any> {
        return AxiosService.get(this.sharePointCustomFieldEndpoint)
    }

    static getById(id: number): Promise<any> {
        return AxiosService.get(this.sharePointCustomFieldEndpoint + '/' + id)
    }

    static create(endpointConfig: any): Promise<any> {
        return AxiosService.post(this.sharePointCustomFieldEndpoint, endpointConfig)
    }

    static update(endpointConfig: any): Promise<any> {
        return AxiosService.put(this.sharePointCustomFieldEndpoint, endpointConfig)
    }

    static delete(id: number) {
        return AxiosService.delete(this.sharePointCustomFieldEndpoint + '/' + id)
    }
}

export default SharePointSettingsRestService